import { isNumeric, textToBinaryString } from './qrcode';

console.log(isNumeric('123feda'));
console.log(textToBinaryString('random string of text'))
